// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as ItemName from "common/src/tft-static/ItemName.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import Switch from "@mui/material/Switch";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";
import FormControlLabel from "@mui/material/FormControlLabel";

function getCols(showLp, param) {
  return Belt_Array.concat([
              StatsTable2.col(false, undefined, (function (param, param$1) {
                      return param$1.t("Unit");
                    }), undefined, (function (param, param$1, param$2) {
                      var itemId = param[1];
                      var unitId = param[0];
                      if (unitId === "") {
                        return React.createElement(ItemTooltip.make, {
                                    itemId: itemId,
                                    children: React.createElement("div", {
                                          className: "flex items-center overflow-hidden"
                                        }, React.createElement(ItemImage.make, {
                                              itemId: itemId,
                                              size: 26,
                                              rounded: "rounded"
                                            }), React.createElement("div", {
                                              className: "pl-2 font-roboto font-normal truncate"
                                            }, React.createElement(ItemName.make, {
                                                  itemId: itemId
                                                })))
                                  });
                      } else {
                        return React.createElement("div", {
                                    className: "flex items-center overflow-hidden"
                                  }, React.createElement(UnitImage.make, {
                                        unitId: unitId,
                                        size: 28
                                      }), React.createElement(ItemTooltip.make, {
                                        itemId: itemId,
                                        children: React.createElement(ItemImage.make, {
                                              itemId: itemId,
                                              size: 26,
                                              className: "ml-2",
                                              rounded: "rounded"
                                            })
                                      }), React.createElement("div", {
                                        className: "pl-2 font-roboto font-normal truncate"
                                      }, React.createElement(UnitName0.make, {
                                            unit: unitId
                                          })));
                      }
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param$2.unitsT(param[0]) + param$2.itemsT(param[1]);
                    }), undefined, 200, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Games");
                    }), undefined, (function (param, param$1, param$2) {
                      return String(param[2].count);
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[2].count;
                    }), undefined, 80, undefined, undefined),
              StatsTable2.col(false, true, (function (param, param$1) {
                      return param$1.t("Place");
                    }), undefined, (function (param, param$1, param$2) {
                      return param[2].place.toFixed(2);
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[2].place;
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Top 4");
                    }), undefined, (function (param, param$1, param$2) {
                      var v = param[2];
                      return Global.formatPct(undefined, Global.f(v.top4) / Global.f(v.count)) + "%";
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var v = param[2];
                      return Global.f(v.top4) / Global.f(v.count);
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Win");
                    }), undefined, (function (param, param$1, param$2) {
                      var v = param[2];
                      return Global.formatPct(undefined, Global.f(v.top1) / Global.f(v.count)) + "%";
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var v = param[2];
                      return Global.f(v.top1) / Global.f(v.count);
                    }), undefined, 75, undefined, undefined)
            ], showLp ? [StatsTable2.col(undefined, true, (function (param, param$1) {
                        return param$1.t("LP");
                      }), undefined, (function (param, param$1, param$2) {
                        var v = param[2];
                        return (
                                v.lp > 0 ? "+" : ""
                              ) + String(v.lp);
                      }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                        return param[2].lp;
                      }), undefined, 70, undefined, undefined)] : []);
}

function PlUnitItemsSummary(Props) {
  var showLp = Props.showLp;
  var games = Props.games;
  var top = Props.top;
  var isDuo = Props.isDuo;
  var scrollRef = Props.scrollRef;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return false;
      });
  var setSplit = match[1];
  var split = match[0];
  var unitsT = Translation.useT(/* Units */1);
  var data = React.useMemo((function () {
          var unitGroups = Belt_MutableMapString.make(undefined);
          Belt_Array.forEach(games, (function (hero) {
                  var match = hero.rankBefore;
                  var match$1 = hero.rankAfter;
                  var rankChange;
                  var exit = 0;
                  if (match !== undefined && match$1 !== undefined) {
                    var before = LpChartUtils.divisionToBase(match[0], set) + match[1] | 0;
                    var after = LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0;
                    rankChange = after - before | 0;
                  } else {
                    exit = 1;
                  }
                  if (exit === 1) {
                    rankChange = hero.queueId === 1100 ? PlUtils.getEstimatedLp(hero.info.placement) : 0;
                  }
                  return Belt_Array.forEach(Belt_SetString.toArray(Belt_SetString.fromArray(Belt_Array.concatMany(Belt_Array.map(hero.info.units, (function (unit) {
                                                var items = unit.items2.includes("ThiefsGloves") ? ["ThiefsGloves"] : unit.items2;
                                                var items$1 = items.includes("5ThiefsGlovesRadiant") ? ["5ThiefsGlovesRadiant"] : unit.items2;
                                                return Belt_Array.map(Belt_Array.keep(items$1, (function (id) {
                                                                  var info = Data.itemInfo(id, set);
                                                                  if (info !== undefined) {
                                                                    return Caml_option.valFromOption(info).id > 8;
                                                                  } else {
                                                                    return false;
                                                                  }
                                                                })), (function (i) {
                                                              return (
                                                                      split ? unit.id : ""
                                                                    ) + "__" + i;
                                                            }));
                                              }))))), (function (key) {
                                var group = Belt_MutableMapString.getWithDefault(unitGroups, key, []);
                                group.push([
                                      hero.info.placement,
                                      rankChange
                                    ]);
                                return Belt_MutableMapString.set(unitGroups, key, group);
                              }));
                }));
          var unitGroups$1 = Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(unitGroups), (function (param, param$1) {
                  return -Caml.caml_int_compare(param[1].length, param$1[1].length) | 0;
                }));
          var unitGroups$2 = Belt_SortArray.stableSortBy(unitGroups$1, (function (tg1, tg2) {
                  return -Caml.caml_int_compare(tg1[1].length, tg2[1].length) | 0;
                }));
          var minCount = Caml.caml_int_min(5, Belt_Option.mapWithDefault(Belt_Array.get(unitGroups$2, 24), 0, (function (param) {
                      return param[1].length;
                    })));
          var len = unitGroups$2.findIndex(function (param) {
                return param[1].length < minCount;
              });
          var unitGroups$3 = len === -1 ? unitGroups$2 : Belt_Array.slice(unitGroups$2, 0, len);
          return Belt_Array.map(unitGroups$3, (function (param) {
                        var places = param[1];
                        var parts = param[0].split("__");
                        var unitId = Belt_Array.getExn(parts, 0);
                        var itemId = Belt_Array.getExn(parts, 1);
                        var c = places.length;
                        var avg = Global.f(Belt_Array.reduce(places, 0, (function (acc, param) {
                                    var p = param[0];
                                    return acc + (
                                            isDuo ? T.duoPlace(p) : p
                                          ) | 0;
                                  }))) / Global.f(places.length);
                        var top4 = Belt_Array.keep(places, (function (param) {
                                var p = param[0];
                                if (p <= 4) {
                                  return p >= 1;
                                } else {
                                  return false;
                                }
                              })).length;
                        var win = Belt_Array.keep(places, (function (param) {
                                var p = param[0];
                                if (isDuo) {
                                  return p <= 2;
                                } else {
                                  return p === 1;
                                }
                              })).length;
                        var lp = Belt_Array.reduce(places, 0, (function (acc, param) {
                                return acc + param[1] | 0;
                              }));
                        return [
                                unitId,
                                itemId,
                                {
                                  count: c,
                                  place: avg,
                                  top4: top4,
                                  top1: win,
                                  lp: lp
                                }
                              ];
                      }));
        }), [
        games,
        split
      ]);
  var keyFn = React.useCallback((function (param) {
          return param[0] + param[1];
        }), []);
  var cols = React.useMemo((function () {
          return getCols(showLp, unitsT);
        }), [
        showLp,
        unitsT
      ]);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "pt-1 pl-6"
                }, React.createElement(FormControlLabel, {
                      control: React.createElement(Switch, {
                            checked: split,
                            onChange: (function (e) {
                                return Curry._1(setSplit, e.target.checked);
                              }),
                            size: "small"
                          }),
                      label: t("Split by item holder")
                    })), React.createElement(StatsTable2.make, {
                  cols: cols,
                  data: data,
                  context: undefined,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  top: top,
                  defaultSortIdx: 1,
                  scrollEl: [
                    scrollRef,
                    0
                  ]
                }));
}

var make = React.memo(PlUnitItemsSummary);

export {
  getCols ,
  make ,
  
}
/* make Not a pure module */
